module.exports = __webpack_public_path__ + "img/logo.98ea8ce6.png";